import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimonial = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };
  return (
    <div>
      <section id="testimonials" className="testimonials">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-lg-5 info"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <h3>Testimonials</h3>
              <p>
                Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis
                aute irure dolor in reprehenderit in voluptate velit esse cillum
                dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident.
              </p>
            </div>

            <div className="col-lg-7" data-aos="fade-up" data-aos-delay="200">
              <Slider {...settings}>
                <div>
                  {
                    <div className="swiper-slide">
                      <div className="testimonial-item">
                        <div className="d-flex">
                          <img
                            src="assets/img/testimonials/testimonials-3.jpg"
                            className="testimonial-img flex-shrink-0"
                            alt=""
                          />
                          <div>
                            <h3>Jena Karlis</h3>
                            <h4>Store Owner</h4>
                            <div className="stars">
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                            </div>
                          </div>
                        </div>
                        <p>
                          <i className="bi bi-quote quote-icon-left"></i>
                          <span>
                            Enim nisi quem export duis labore cillum quae magna
                            enim sint quorum nulla quem veniam duis minim tempor
                            labore quem eram duis noster aute amet eram fore
                            quis sint minim.
                          </span>
                          <i className="bi bi-quote quote-icon-right"></i>
                        </p>
                      </div>
                    </div>
                  }
                </div>
                <div>
                  {
                    <div className="swiper-slide">
                      <div className="testimonial-item">
                        <div className="d-flex">
                          <img
                            src="assets/img/testimonials/testimonials-3.jpg"
                            className="testimonial-img flex-shrink-0"
                            alt=""
                          />
                          <div>
                            <h3>Jena Karlis</h3>
                            <h4>Store Owner</h4>
                            <div className="stars">
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                            </div>
                          </div>
                        </div>
                        <p>
                          <i className="bi bi-quote quote-icon-left"></i>
                          <span>
                            Enim nisi quem export duis labore cillum quae magna
                            enim sint quorum nulla quem veniam duis minim tempor
                            labore quem eram duis noster aute amet eram fore
                            quis sint minim.
                          </span>
                          <i className="bi bi-quote quote-icon-right"></i>
                        </p>
                      </div>
                    </div>
                  }
                </div>
                <div>
                  {
                    <div className="swiper-slide">
                      <div className="testimonial-item">
                        <div className="d-flex">
                          <img
                            src="assets/img/testimonials/testimonials-3.jpg"
                            className="testimonial-img flex-shrink-0"
                            alt=""
                          />
                          <div>
                            <h3>Jena Karlis</h3>
                            <h4>Store Owner</h4>
                            <div className="stars">
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                            </div>
                          </div>
                        </div>
                        <p>
                          <i className="bi bi-quote quote-icon-left"></i>
                          <span>
                            Enim nisi quem export duis labore cillum quae magna
                            enim sint quorum nulla quem veniam duis minim tempor
                            labore quem eram duis noster aute amet eram fore
                            quis sint minim.
                          </span>
                          <i className="bi bi-quote quote-icon-right"></i>
                        </p>
                      </div>
                    </div>
                  }
                </div>
                <div>
                  {
                    <div className="swiper-slide">
                      <div className="testimonial-item">
                        <div className="d-flex">
                          <img
                            src="assets/img/testimonials/testimonials-3.jpg"
                            className="testimonial-img flex-shrink-0"
                            alt=""
                          />
                          <div>
                            <h3>Jena Karlis</h3>
                            <h4>Store Owner</h4>
                            <div className="stars">
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                            </div>
                          </div>
                        </div>
                        <p>
                          <i className="bi bi-quote quote-icon-left"></i>
                          <span>
                            Enim nisi quem export duis labore cillum quae magna
                            enim sint quorum nulla quem veniam duis minim tempor
                            labore quem eram duis noster aute amet eram fore
                            quis sint minim.
                          </span>
                          <i className="bi bi-quote quote-icon-right"></i>
                        </p>
                      </div>
                    </div>
                  }
                </div>
                <div>
                  {
                    <div className="swiper-slide">
                      <div className="testimonial-item">
                        <div className="d-flex">
                          <img
                            src="assets/img/testimonials/testimonials-3.jpg"
                            className="testimonial-img flex-shrink-0"
                            alt=""
                          />
                          <div>
                            <h3>Jena Karlis</h3>
                            <h4>Store Owner</h4>
                            <div className="stars">
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                            </div>
                          </div>
                        </div>
                        <p>
                          <i className="bi bi-quote quote-icon-left"></i>
                          <span>
                            Enim nisi quem export duis labore cillum quae magna
                            enim sint quorum nulla quem veniam duis minim tempor
                            labore quem eram duis noster aute amet eram fore
                            quis sint minim.
                          </span>
                          <i className="bi bi-quote quote-icon-right"></i>
                        </p>
                      </div>
                    </div>
                  }
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonial;
